import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import {default as Reactsel} from 'react-select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import AdminInternalResource from './AdminInternalResource'
import AdminExternalResource from './AdminExternalResource'

class AdminResource extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            errorMsg: '',
    		data: {
    			nameOfCompetency: '',
    			idOfCompetency: '',
                levels: [],
                tracks: [],
                levelId: '',
                trackId: ''
    		},
            externalResourceDetails: [],
            internalResourceDetails: [],
            resourceView: 'default',
            fetchCount: 0
    	}
    }

    handleLevelsChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.levelId = event.target.value
        this.setState({data: data})
    }

    handleComptencyPageReturn = (event) => {
        this.props.handleCompetencyPageBackAction(this.props.user.accessToken)
    }
    
    handleFetch = (e) => {
        e.preventDefault()
        if ((this.state.data.levelId == '') && (this.state.data.trackId == '')){
            return this.setState({errorMsg: 'Please choose a Level and Track to fetch.'})
        }
        else if(this.state.data.levelId == ''){
            return this.setState({errorMsg: 'Please choose a Level.'})
        }
        else if(this.state.data.trackId == ''){
            return this.setState({errorMsg: 'Please choose a Track.'})
        }
        let externalResourceDetails = this.state.externalResourceDetails
        let internalResourceDetails = this.state.internalResourceDetails
        api.adminResourceDetails(this.props.user.accessToken, this.state.data.idOfCompetency, this.state.data.levelId, this.state.data.trackId)
        .then((result) => {
            externalResourceDetails = result.external
            internalResourceDetails = result.internal
            this.setState({externalResourceDetails: externalResourceDetails, internalResourceDetails: internalResourceDetails, errorMsg: ''})
        })
        
    }

    handleTracksChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.trackId = event.target.value
        this.setState({data: data})
    }

    componentDidMount() {
        let data = Object.assign({}, this.state.data)
        data.nameOfCompetency = this.props.nameOfCompetency
        data.idOfCompetency = this.props.idOfCompetency
        this.setState({data: data})

        return api.getCertificationLevels(this.props.user.accessToken)
        .then((result) => {
            data.levels = result.certification_level
            var genLevel = {};
            genLevel["id"] = 0;
            genLevel["name"] = "General";
            data.levels.push(genLevel)
            api.getTestTracks(this.props.user.accessToken,'mc')
            .then((result) => {
                data.tracks = result
                var a = {};
                a["id"] = 0;
                a["name"] = "General";
                data.tracks.push(a)
                this.setState({data: data})
            })
        })
    }

    render() {
        let internalResourceComponent = null
        let externalResourceComponent
        let fetchCount = this.state.fetchCount
        let handleFetch = this.handleFetch
        let handleFormOpen = this.handleFormOpen
        let handleFormClose = this.handleFormClose
        
        internalResourceComponent=(

                 <AdminInternalResource internalResourceDetails = {this.state.internalResourceDetails}
                 competencyId = {this.state.data.idOfCompetency} />
            );
        
        
            externalResourceComponent=(    
                 <AdminExternalResource externalResourceDetails = {this.state.externalResourceDetails} 
                 competencyId = {this.state.data.idOfCompetency} />
            )
       
    	return (
    		<div>
                <Grid>
                    <GridCell span="1">
                        <Button raised style={{width: '100%'}} onClick={this.handleComptencyPageReturn}>Back</Button>
                    </GridCell>
                    <GridCell span="12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline6">{this.state.data.nameOfCompetency} - Resource View</Typography>
                        </Card>
                    </GridCell>
                    <GridCell span="12">
                        <Grid>
                            <GridCell span="6">
                                <Select
                                    name="mcLevels"
                                    onChange={this.handleLevelsChange}
                                    value={this.state.data.levelId}
                                    className="select-component"
                                    placeholder="--Select Level--">
                                    {this.state.data.levels.map(level => (
                                        <option key={level.id} value={level.id} data-name={level.name}>
                                            {level.name}
                                        </option>
                                    ))}
                                </Select>
                            </GridCell>
                            <GridCell span="4">
                                <Select
                                    name="mcTracks"
                                    onChange={this.handleTracksChange}
                                    value={this.state.data.trackId}
                                    className="select-component"
                                    placeholder="--Select Track--">
                                    {this.state.data.tracks.map(track => (
                                        <option key={track.id} value={track.id} data-name={track.name}>
                                            {track.name}
                                        </option>
                                    ))}
                                </Select>
                            </GridCell>
                            <GridCell span="2">
                                <Button raised style={{ width: '100%' }} onClick= {((e) => handleFetch(e))}>Fetch</Button>
                            </GridCell>
                        </Grid>
                        <StatusMessage error_msg = {this.state.errorMsg} />
                    </GridCell>
                </Grid>
                {internalResourceComponent}
                {externalResourceComponent}
            </div>
    	);
    }	
}


function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminResource);


// WEBPACK FOOTER //
// ./src/views/admin/AdminResource.jsx